/**
 * When a run asks whether the sound of its videos is processed too (PRD-0115 SC-001, SC-002):
 * once, when it holds a video the platform can analyse, or names folders that may hold one (the
 * server resolves a folder's contents; the answer is ignored for a run that held no video). A run
 * of anything else asks nothing. Pure.
 */
import type { VideoSoundScope } from '@/components/documents/VideoSoundQuestion'
import { isVideoFileType } from '@/utils/video-file'

/** What the question is asked about, or null when the run asks nothing. */
export function videoSoundScope(
  fileTypes: readonly (string | null | undefined)[],
  folderCount: number,
  videoAvailable: boolean
): VideoSoundScope | null {
  if (!videoAvailable) return null
  if (fileTypes.some(isVideoFileType)) return {}
  return folderCount > 0 ? { folders: true } : null
}
